import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';

const ConfirmContext = createContext();

// Замена window.confirm в стиле сайта:
//   if (!(await confirm('Удалить склад?', { confirmText: 'Удалить' }))) return;
// Опции: title, confirmText, cancelText, danger (красная кнопка, по умолчанию да).
export function useConfirm() {
  return useContext(ConfirmContext);
}

export function ConfirmProvider({ children }) {
  const [dialog, setDialog] = useState(null);
  const current = useRef(null);

  const close = useCallback((result) => {
    current.current?.resolve(result);
    current.current = null;
    setDialog(null);
  }, []);

  const confirm = useCallback((message, options = {}) => new Promise(resolve => {
    current.current?.resolve(false);
    current.current = { message, ...options, resolve };
    setDialog(current.current);
  }), []);

  useEffect(() => {
    if (!dialog) return;
    const onKey = (e) => { if (e.key === 'Escape') close(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [dialog, close]);

  const danger = dialog?.danger !== false;
  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {dialog && (
        // Поверх других модалок: подтверждение бывает внутри окна редактирования
        <div className="modal-overlay" style={{ zIndex: 300 }} onMouseDown={e => { if (e.target === e.currentTarget) close(false); }}>
          <div className="modal" role="alertdialog" aria-modal="true" style={{ maxWidth: 420 }}>
            <h3>{dialog.title || 'Подтверждение'}</h3>
            <p style={{ margin: '16px 0', color: 'var(--text-secondary)', whiteSpace: 'pre-line' }}>{dialog.message}</p>
            <div className="modal-actions">
              <button className="btn btn-outline" onClick={() => close(false)}>{dialog.cancelText || 'Нет'}</button>
              <button className="btn btn-primary" style={danger ? { background: 'var(--danger)' } : undefined} autoFocus onClick={() => close(true)}>{dialog.confirmText || 'Да, подтверждаю'}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}
